/**
 * Конвертирует ISO-дату и время в таком формате `2023-12-20T10:18:47Z` или `2023-12-20`
 * в формат переданный в `format`.
 * @param date - Дата или дата и время в формате ISO 8601
 * @param format - Формат, к которому необходимо привести дату, например `dd/MM/yyyy`, `dd/MM/yy`, `dd-mm-yyyy`, `hh:mm`
 * @returns Дата сконвертированная в необхимый формат, например `11/09/2023`, `11/09/23`, `11-09-2023`, `04:40`
 */
export const convertIsoDate = (date: string, format: string): string => {
    const inputDate = new Date(date);

    const day = inputDate.getDate().toString().padStart(2, "0");
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
    const yearShort = inputDate.getFullYear().toString().slice(-2);
    const yearLong = inputDate.getFullYear().toString();
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    const formattedDate = format
        .replace("dd", day)
        .replace("MM", month)
        .replace("yyyy", yearLong)
        .replace("yy", yearShort)
        .replace("hh", hours)
        .replace("mm", minutes)
        .replace("ss", seconds);

    return formattedDate;
};
